import React from 'react';
import './Pomodoro.css';
import PomoSettings from './PomoSettings.js';
import moreIcon from './more.png';
import { Router, Link } from "@reach/router"

class Pomodoro extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			cycle: 'work',
			workTime: 25,
			breakTime: 5,
			currentTime: '25:00',
			timerRunning: false,
			settings: false,
			fullScreen: false,
			isPaused: false,
			runningTimer: 0
		};
		this.toggleSettings = this.toggleSettings.bind(this);
		this.handleStartButton = this.handleStartButton.bind(this);
		this.countDownLogic = this.countDownLogic.bind(this)
		this.handleExitButton = this.handleExitButton.bind(this)
		this.handleWorkTime = this.handleWorkTime.bind(this)
		this.handleBreakTime = this.handleBreakTime.bind(this)
		this.startTimer = this.startTimer.bind(this);
		this.handleCurrentTime = this.handleCurrentTime.bind(this)
	}
	
	toggleSettings() {
		if (this.state.settings === false) {
			this.setState({settings: true})
			document.querySelector('.pomo-settings-box').style.display ='block';
		} else {
			this.setState({settings: false})
			document.querySelector('.pomo-settings-box').style.display='none';
			//Adjust any updates on time displayed
			if (this.state.cycle === 'work') {
				this.setState({currentTime: this.state.workTime + ':00'});
			} else {
				this.setState({currentTime: this.state.breakTime +':00'});
			}
		}
	}


	handleWorkTime(value) {
		this.setState({workTime: value})
		console.log(this.state)
	}

	handleBreakTime(value) {
		console.log('working')
		this.setState({breakTime: value})
		console.log(this.state)
	}

	handleStartButton() {
		if (this.state.timerRunning === false) {
			document.querySelector('.pomo-button').innerHTML = 'Pause';
			this.startTimer();
			document.querySelector('.countdown-expanding-ring').style.display = 'block'	
			document.querySelector('.pomo-pause-container').style.display = 'none'	
			document.querySelector('.pomo-exit-button').style.display = 'block'

			this.setState({timerRunning: true, isPaused: false});
			console.log(this.state)
	
		} else {
			console.log('paused')
			// document.querySelector('.pomo-button').innerHTML = 'Start'
			document.querySelector('.countdown-expanding-ring').style.display = 'none'	
			document.querySelector('.pomo-pause-container').style.display = 'block'	
			document.querySelector('.pomo-exit-button').style.display = 'none'
			this.setState({
				timerRunning: false,
				isPaused: true
			});
			
			clearInterval(this.runningTimer)

			;
		}
	}
	async handleExitButton() {
		document.querySelector('.countdown-expanding-ring').style.display = 'none'	
		document.querySelector('.pomo-button').innerHTML = 'Start';
		// document.querySelector('.pomo-exit-button').style.display = 'none'
		let currentTime = this.state.workTime + ':00'
		await this.setState({
			timerRunning: false,
			cycle: 'work',
			currentTime: currentTime,
	
		})
		await clearInterval(this.runningTimer);
		console.log(this.state)
	}

	countDownLogic(time, nextCycle) {
			this.runningTimer = setInterval(() => {
				time = time - 1;
				let minutes = Math.floor(time / 60)
				let seconds = time - (minutes * 60)
				minutes = minutes < 10 ? '0' + minutes : minutes
				seconds = seconds < 10 ? '0' + seconds : seconds
				this.setState({currentTime: minutes + ':' + seconds})
				document.title =  'Home - ' + this.state.currentTime
				if (minutes == 0 && seconds == 0) {
					this.setState({
						cycle: [nextCycle],
						timerRunning: false,
						currentTime: this.state[nextCycle + 'Time'] + ':00'
					});
					clearInterval(this.runningTimer)
					document.querySelector('.pomo-button').innerHTML = nextCycle
					document.querySelector('.countdown-expanding-ring').style.display = 'none';
					document.querySelector('.pomo-exit-button').style.display = 'none'
					document.title =  nextCycle +'!'
				}
			}, 1000)
	}

	startTimer(){
		let timerDuration;
		let time;
		if (this.state.isPaused === true) {
			let currentTime= this.state.currentTime;
			currentTime = currentTime.split(':')
			time = (currentTime[0] * 60) + currentTime[1] * 1
			this.countDownLogic(time, 'break')
		} else if (this.state.cycle === 'work') {
			timerDuration = this.state.workTime;
			time = timerDuration * 60
			this.countDownLogic(time, 'break')
		} else {
			timerDuration = this.state.breakTime;
			time = timerDuration * 60;
			this.countDownLogic(time, 'work')
		}
	}

	handleCurrentTime() {
		console.log('ok')
		if (this.state.cycle === 'work') {
			this.setState({
			currentTime: this.state.workTime + ':00'
			})
		} else {
			this.setState({
			currentTime: this.state.breakTime + ':00'
			})
		}
	}
	

	render() {
		return(
			<div id='pomo' className='pomo-container widget' >
				<div className='pomo-top-section'>
					<Link to='/pomodoro-settings'>
						<img className='more-icon grow' src={moreIcon} alt='icon' />
					</Link>
					<svg className='stats-icon grow' version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 375.148 375.148">
						<g>
							<path d="M222.076,218.936h-68.963c-5.771,0-10.449,4.678-10.449,10.449v135.314c0,5.771,4.678,10.449,10.449,10.449h68.963
								c5.771,0,10.449-4.678,10.449-10.449V229.385C232.525,223.614,227.847,218.936,222.076,218.936z M211.627,354.25h-48.065V239.834
								h48.065V354.25z"/>
							<path d="M358.958,136.911h-69.486c-5.771,0-10.449,4.678-10.449,10.449v217.339c0,5.771,4.678,10.449,10.449,10.449h69.486
								c5.771,0,10.449-4.678,10.449-10.449V147.36C369.407,141.59,364.729,136.911,358.958,136.911z M348.509,354.25h-48.588V157.809
								h48.588V354.25z"/>
							<path d="M85.717,269.613H16.231c-5.771,0-10.449,4.678-10.449,10.449v84.637c0,5.771,4.678,10.449,10.449,10.449h69.486
								c5.771,0,10.449-4.678,10.449-10.449v-84.637C96.166,274.292,91.488,269.613,85.717,269.613z M75.268,354.25H26.68v-63.739
								h48.588V354.25z"/>
							<path d="M370.452,10.479c-1.589-2.19-4.089-3.536-6.792-3.657L268.574,0.03c-5.771-0.433-10.8,3.895-11.233,9.665
								c-0.433,5.771,3.894,10.8,9.665,11.233l67.297,4.57l-123.721,96.786l-94.563-74.188c-4.038-3.198-9.803-2.976-13.584,0.522
								L5.26,141.613c-4.131,3.919-4.363,10.425-0.522,14.629c1.864,2.419,4.786,3.783,7.837,3.657c2.756-0.039,5.385-1.166,7.314-3.135
								l90.384-86.727l93.518,73.665c3.817,3.056,9.244,3.056,13.061,0L350.601,39.624l-5.227,64.896
								c-0.026,5.674,4.279,10.431,9.927,10.971h0.522c5.386,0.027,9.91-4.045,10.449-9.404l6.792-88.294
								C373.447,15.074,372.471,12.34,370.452,10.479z"/>
						</g>
					</svg>
				</div>
				<div className='pomo-middle-section'>
				
					<div className='countdown-expanding-ring' />
					<div className='countdown-ring'>
						<h1 className='countdown'>{this.state.currentTime}</h1>
						<div className='pomo-exit-button'>
							<p onClick={this.handleExitButton}>exit</p>
						</div>
					</div>
				</div>
				<div className='pomo-bottom-section'>
					<div className='pomo-button-box'> 
						<button className='pomo-button' type='button' value='start' onClick={this.handleStartButton}>Start</button>
					</div>
				</div>

				<div className='pomo-pause-container'>
					<div className='pomo-pause-content-wrapper'>
						<svg className='pause-icon pause-item' height="512" viewBox="0 0 511.448 511.448" width="512" xmlns="http://www.w3.org/2000/svg">
							<path d="m436.508 74.94c-99.913-99.913-261.64-99.927-361.567 0-99.913 99.913-99.928 261.64 0 361.567 99.913 99.913 261.64 99.928 361.567 0 99.912-99.912 99.927-261.639 0-361.567zm-202.451 255.45c0 11.598-9.402 21-21 21s-21-9.402-21-21v-149.333c0-11.598 9.402-21 21-21s21 9.402 21 21zm85.333 0c0 11.598-9.402 21-21 21s-21-9.402-21-21v-149.333c0-11.598 9.402-21 21-21s21 9.402 21 21z"/>
						</svg>
						<h4 className='pause-header pause-item'>Paused</h4>
						<p className='pause-sub-header pause-item'>Get back to it when you are ready</p>
						<button className='pause-button' type='button' onClick={this.handleStartButton}>Let's Go</button>
					</div>
				</div>
				<Router>
					<PomoSettings path='/pomodoro-settings'
						breakTime={this.state.breakTime} 
						workTime={this.state.workTime} 
						handleWorkTime={this.handleWorkTime}
						handleBreakTime={this.handleBreakTime}
						toggleSettings={this.toggleSettings}
						handleCurrentTime={this.handleCurrentTime}
						/>
				</Router>
			</div>
		)
	}
}

export default Pomodoro;